<template>
  <a-card title="首页弹窗">
    <a-tabs v-model:activeKey="formSearch.region_code" @change="handleTableChange()" >
      <a-tab-pane key="" tab="全部"></a-tab-pane>
      <a-tab-pane key="CN" tab="中国 CN"></a-tab-pane>
      <a-tab-pane key="US" tab="美国 US"></a-tab-pane>
    </a-tabs> 
    <a-space >
      <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
        <a-form-item label="标题" name="title">
          <a-input 
            :allowClear="true"
            placeholder="标题" 
            v-model:value="formSearch.title" 
            />
        </a-form-item>
        <a-form-item label="地区" name="region_code">
         <a-select
          :allowClear="true"
          style="width: 100px;"
          v-model:value="formSearch.region_code"
          :options="NationCodes"
         />
        </a-form-item>
        <a-form-item  label="状态"  name="status">
          <a-select
            style="width: 100px;"
            v-model:value="formSearch.status"
            :options="status"
          />
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            @click="handleTableChange()"
            shape="circle"
          >
          <template #icon><SearchOutlined /></template>
          </a-button>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            @click="handleCreate"
          >
          新建
          </a-button>
        </a-form-item>
      </a-form>
    </a-space>

    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
    <a-table 
      class="ant-table-striped"
      :row-key="record => record.id"
      :data-source="dataSource" 
      :columns="columns" 
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange()"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >
      <!-- <template #style_name="{ record }">
        {{ styleNames[record.style_id]}}
      </template> -->
      <template #image_url="{ record }">
        <a-image
          style="width: 100px;"
          placehoder="true"
          :src="record.image_url" width="100"
        />
      </template>
      <template #operator_id="{ record }">
        <Username :user_id="record.operator_id" />
      </template>
      <template #sort="{ record }">
        <a-input-group compact>
          <a-input v-model:value="record.sort"  style="width: 60px;" />
          <a-button type="primary" @click="handleModifySort(record)"  >设置</a-button>
        </a-input-group>
      </template>
      <template #status="{ record }">
        <a-tag v-if="record.status == 1" color="green">已上线</a-tag>
        <a-tag v-if="record.status == 0" color="gray">已下线</a-tag>
        <a-tag v-if="record.status == 2" color="yellow">预览中</a-tag>
      </template>
      <template #action="{ record }">
       <a-space>
        <a-button @click="handleModifyStatus(record, '1')" v-if="record.status == 2" type="primary">上线</a-button>
        <a-button @click="handleModifyStatus(record, '0')"  v-if="record.status == 2 || record.status == 1"  danger >下线</a-button>
        <a-button @click="handleModifyStatus(record, '2')"  v-if="record.status == 0"  warning >测试环境预览</a-button>
        <a-button  warn @click="handleUpdate(record)"  >编辑</a-button>
        <a-popconfirm
          title="确定删除吗?"
          ok-text="确定"
          cancel-text="不了"
          @confirm="handleDelete(record)"
        >
          <a-button v-if="record.is_delete == 0"   danger   >删除</a-button>
        </a-popconfirm>
       </a-space>
      </template>
      </a-table>
  </a-card>
  <a-modal v-model:visible="openDia" :title="formRecord.id == 0 ? '新建' : '编辑'" 
  @cancel="resetForm" @ok="handleConfirm" :confirm-loading="loading" width="880px" destroy-on-close>
    <a-form :label-col="{ span: 5 }" :model="formRecord" :disabled="formRecord.status != 0"  style="margin: 10px auto;" :rules="rules" ref="formRef" >
        <a-form-item required label="后台标题" name="title">
          <a-input placeholder="后台标题" v-model:value="formRecord.title" />
        </a-form-item>
        <a-form-item required label="国家地区" name="region_code">
          <a-select
            style="width: 100px;"
            v-model:value="formRecord.region_code"
            :options="NationCodes"
          />
          ({{ formRecord.region_code }})
        </a-form-item>
        <p>模板列表</p>
        <VueDraggable
          v-if="formRecord.content.templates.length > 0"
          v-model="formRecord.content.templates"
          ghost-class="ghost"
          handle=".template-drag-handle"
        >
          <div
            v-for="(element, index) in formRecord.content.templates"
            :key="element.template_id"
            class="template-item"
          >
            <div class="template-header">
              <div class="template-header-left">
                <span class="template-drag-handle">☰ 内容项 {{ index + 1 }}</span>
              </div>
              <a-button danger @click="removeItem(index)" v-if="formRecord.content.templates.length > 1">删除</a-button>
            </div>
            <div style="display: flex;flex-direction: row;" >
              <div >
                <div class="popup-preview" v-if="element.template_id && templateInfo[element.template_id]">
                  <img class="popup-preview-cover" :src="templateInfo[element.template_id].image_url" alt="封面" />
                   <div v-if="element.label_zh" class="popup-preview-label">
                    {{ element.label_zh || '热门' }}
                  </div>
                  <div class="popup-preview-title">
                    {{ element.title_zh || templateInfo[element.template_id].name_zh || '-' }}
                  </div>
                  <div class="popup-preview-desc">
                    {{ element.desc_zh || '-' }}
                  </div>
                 
                  <div class="popup-preview-btn">
                    {{ element.btntext_zh || '立即生成' }}
                  </div>
                </div>
              </div>
              <div style="flex:1;">
                <a-form-item label="*模板 ID" :name="`template_id_${index}`">
                  <a-input placeholder="模板 ID" v-model:value="element.template_id" @change="() => debouncedFetchTemplateInfo(element.template_id)" />
                  <!-- 模板信息展示区域 -->
                  <div class="template-info-container">
                    <!-- 加载状态 -->
                    <div v-if="element.template_id && templateLoading[element.template_id]" class="template-loading">
                      <a-spin size="small" />
                      <span>正在获取模板信息...</span>
                    </div>
                    
                    <!-- 错误信息 -->
                    <a-alert v-else-if="element.template_id && templateError[element.template_id]" type="error" message="获取模板信息失败" :description="templateError[element.template_id]" show-icon />
                    
                    <!-- 模板信息 -->
                    <div v-else-if="element.template_id && templateInfo[element.template_id]" class="template-info">
                      <h4 class="template-info-title">模板信息</h4>
                      <div class="template-info-content">
                        <!-- 封面图片 -->
                        <div v-if="templateInfo[element.template_id].image_url" class="template-info-image">
                          <img :src="templateInfo[element.template_id].image_url" alt="封面" />
                        </div>
                        
                        <!-- 模板详情 -->
                        <div class="template-info-details">
                          <div class="template-info-item">
                            <span v-if="templateInfo[element.template_id].status != 1">未上线</span>
                            <span class="template-info-label">标题:</span>
                            <span class="template-info-value primary">{{ templateInfo[element.template_id].title || '-' }}</span>
                            <i18nText v-model:zh="templateInfo[element.template_id].name_zh" v-model:value="templateInfo[element.template_id].name" />
                          </div>
                          <div class="template-info-item">
                            <span class="template-info-label">Tab名称:</span>
                            <span class="template-info-value">{{ templateInfo[element.template_id].tab_name || '-' }}</span>
                          </div>
                          <div class="template-info-item">
                            <span class="template-info-label">工具ID:</span>
                            <span class="template-info-value">{{ templateInfo[element.template_id].tool_id || '-' }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a-form-item>
                
                <a-form-item label="*描述" :name="`desc_${index}`">
                  <Inputi18nInline showTitle="true" v-model:zh="element.desc_zh" v-model:valid="element.desc_valid" v-model:value="element.desc" />
                </a-form-item>
                <a-form-item label="标题" :name="`title_${index}`" class="form-item-mb-10">
                  <Inputi18nInline showTitle="true" v-model:zh="element.title_zh" v-model:valid="element.title_valid" v-model:value="element.title"  />
                   <p>*不填默认是模板名称</p>
                </a-form-item>
                <a-form-item label="按钮文案" :name="`btntext_${index}`" class="form-item-mb-10">
                  <Inputi18nInline showTitle="true" v-model:zh="element.btntext_zh" v-model:valid="element.btntext_valid" v-model:value="element.btntext" />
                  <p>*不填默认 立即生成 / Create Now</p>
                </a-form-item>
                <a-form-item label="标签" :name="`label_${index}`" class="form-item-mb-10">
                  <Inputi18nInline showTitle="true" v-model:zh="element.label_zh" v-model:valid="element.label_valid" v-model:value="element.label" />
                  <p>*不填默认 热门 / Popular</p>
                </a-form-item>
              </div>
            </div>
            
          </div>
        </VueDraggable>
        
        <a-button type="dashed" block @click="addItem" style="margin-top: 15px;">
          添加内容项
        </a-button>
      </a-form>
  </a-modal>
  <!-- <UserEditor v-model:visible="userEditorVisible" @cancle="userEditorVisible=false" /> -->

</template>
<script>
import { defineComponent, onMounted } from 'vue'
// import UserEditor from '@/components/UserEditor.vue'
import { SearchOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import request from '@/utils/request'
import { Modal } from 'ant-design-vue';
import { useStore } from 'vuex'
import Username from '@/components/Username.vue'  
import Inputi18n from '@/components/Inputi18n.vue'
import Inputi18nInline from '@/components/Inputi18nInline.vue'
import i18nText from '@/components/i18nText.vue'
import { NationCodes } from '@/utils/macro'
import { debounce } from 'lodash'
import { VueDraggable } from 'vue-draggable-plus'
import { generateRandomString } from '@/utils/string'


const DefaultRecord = {
  "id": 0,
  "title": "",
  "content": {
    "templates": [
    ]
  },
  "region_code": "CN",
  "status": 0,
}
export default defineComponent({
  components: {
    SearchOutlined, Username, 
    // Inputi18n, 
    VueDraggable,Inputi18nInline,i18nText
  },
  data(){
    return {
      NationCodes,
      styleNames :{},
      loading: false,
      openDia: false,
      dataSource: [],
      action_image_index: 0,
      formRecord: {
        ...DefaultRecord
      },
      templateInfo: {}, // 存储模板信息
      templateLoading: {}, // 存储模板信息加载状态
      templateError: {}, // 存储模板信息错误状态
      rules:{
        title: [
          { required: true, message: 'required', trigger: 'change' },
        ],
      },
      pagination: {
        total: 1,
        current: 0,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',
      status: [
      {
          label: '全部',
          value: ''
        },
        {
          label: '上线',
          value: '1'
        },
        {
          label: '下线',
          value: '0'
        },
        {
          label: '预览',
          value: '2'
        },
      ],
       formSearch: {
        title:'',
        status: '',
        region_code: '',
      },
      searchPosition : 'top',
      uploadLoading: false,
    }
  },
  mounted(){
    this.handleTableChange()
  },
  methods: {
    async handleConfirm(){
      if (this.formRecord.status != 0) {
        message.error('请先下线才能编辑');
        return;
      }
      // 表单级别的必填字段校验
      if (!this.formRecord.title || this.formRecord.title.trim() === '') {
        message.error('后台标题不能为空');
        return;
      }
      
      if (!this.formRecord.region_code || this.formRecord.region_code.trim() === '') {
        message.error('国家地区不能为空');
        return;
      }
      
      // 校验 templates 数组
      if (!this.formRecord.content || !Array.isArray(this.formRecord.content.templates)) {
        message.error('模板列表不能为空');
        return;
      }
      
      if (this.formRecord.content.templates.length === 0) {
        message.error('至少需要一个模板项');
        return;
      }
      
      // 校验每个 template 项的必填字段
      for (let i = 0; i < this.formRecord.content.templates.length; i++) {
        const template = this.formRecord.content.templates[i];
        
        if (!template.template_id || template.template_id.trim() === '') {
          message.error(`第 ${i + 1} 个模板项的模板 ID 不能为空`);
          return;
        }
        
        if (template.title_valid === false) {
          template.title = ''
        }
        
        if (template.desc_valid === false) {
          message.error(`第 ${i + 1} 个模板项的描述文案国际化文案未配置`);
          return;
        }

        if (template.btntext_valid === false) {
          template.btntext = ''
        }
        
        if (template.label_valid === false) {
          template.label = ''
        }
        
        // label 字段可选，不需要校验
      }
      
      // 校验通过，发送请求
      if (this.formRecord.id) {
        const rsp = await request.put(`/api/popups/${this.formRecord.id}`, {
          ...this.formRecord,
        })
      } else {
        const rsp = await request.post('/api/popups/create', {
          ...this.formRecord,
        })
      }
     
      this.openDia = !this.openDia
      this.loading = false
      this.handleTableChange()
    },
    handleCreate(){
      this.openDia = true
      
      // 初始化所有表单相关数据
      let data = {
        ...DefaultRecord
      }
      this.formRecord = data
      // 初始化模板信息、加载状态和错误状态
      this.templateInfo = {}
      this.templateLoading = {}
      this.templateError = {}
    },
    handleUpdate(record){
      this.openDia = true
      let data = JSON.parse(JSON.stringify(record))
      this.formRecord = data
      
      // 遍历 templates 数组，获取每个 template_id 的模板信息
      this.formRecord.content.templates.forEach((template) => {
        if (template.template_id) {
          this.fetchTemplateInfo(template.template_id)
        }
      })
    },
    async handleDelete(record){
      this.loading = true
      await request.delete(`/api/popups/${record.id}`, { })
      this.loading = false
      this.handleTableChange()
    },
    async handleModifySort(record){
      this.loading = true
      await request.put(`/api/popups/${record.id}`, {
        sort: +record.sort,
      })
      this.loading = false
      this.handleTableChange()
    },
    async handleModifyStatus(record, status){
      this.loading = true
      await request.put(`/api/popups/${record.id}`, {
        status: +status,
      })
      this.loading = false
      this.handleTableChange()
    },
    resetForm() {
      this.$refs.formRef.resetFields();
    },
    addItem() {
      let id = `${generateRandomString()}`
      this.formRecord.content.templates.push({
        idx: Date.now().toString(),
        title: `popup.title.${id}`,
        title_valid: false,
        label: `popup.label.${id}`,
        label_valid: false,
        btntext: `popup.btntext.${id}`,
        btntext_valid: false,
        desc: `popup.desc.${id}`,
        desc_valid: false
      })
    },
    removeItem(index) {
      this.formRecord.content.templates.splice(index, 1)
    },
    // 防抖处理获取模板信息
    debouncedFetchTemplateInfo: debounce(async function(templateId) {
      await this.fetchTemplateInfo(templateId)
    }, 500),
    // 获取模板信息
    async fetchTemplateInfo(templateId) {
      templateId = +templateId
      if (!templateId) {
        message.error('请输入正确的模板 ID');
        return
      }
      
      // 设置加载状态
      this.templateLoading[templateId] = true
      this.templateError[templateId] = ''
      try {
        const rsp = await request.get(`/api/creation/options`, {
          template_id: templateId,
          status: 1,
          limit: 1
        })
        
        if (rsp.data.list && rsp.data.list[0]) {
          this.templateInfo[templateId] = rsp.data.list[0]
          this.templateInfo[templateId].name_valid = this.templateInfo[templateId].name !== ''
        } else {
          this.templateInfo[templateId] = null
          this.templateError[templateId] = '未找到该模板信息'
        }
      } catch (error) {
        console.error('获取模板信息失败:', error)
        this.templateInfo[templateId] = null
        this.templateError[templateId] = '获取模板信息失败，请稍后重试'
      } finally {
        this.templateLoading[templateId] = false
      }
    },
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      this.loading = true
      const rsp = await request.get('/api/popups/search', {
        offset: (pagi.current - 1) * pagi.pageSize ,
        limit: pagi.pageSize,
        ...this.formSearch
      })
      this.loading = false
      this.dataSource = [].concat(rsp.data.list)
      for (let item of this.dataSource) {
        for (let tmpl of item.content.templates) {
          let i18nidx = generateRandomString()
          tmpl.idx = tmpl.template_id
          tmpl.desc_valid = tmpl.desc !== ''
          tmpl.label_valid = tmpl.label !== ''
          tmpl.title_valid = tmpl.title !== ''
          tmpl.btntext_valid = tmpl.btntext !== ''
          if (tmpl.label == '') {
            tmpl.label = `popup.label.${i18nidx}`
          }
          if (tmpl.title == '') {
            tmpl.title = `popup.title.${i18nidx}`
          }
          if (tmpl.btntext == '') {
            tmpl.btntext = `popup.btntext.${i18nidx}`
          }
        }
      }
      this.noticeMessage = `共 ${rsp.data.pagination.total} 条`
      this.pagination.total = rsp.data.pagination.total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
      columns: [
      {
          title: 'id',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: '标题',
          dataIndex: 'title',
          key: 'title',
          width: 200,
        },
       {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          slots: { customRender: 'status' },
        },
        {
          title: '地区',
          dataIndex: 'region_code',
          key: 'region_code',
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
        },
        {
          title: '修改时间',
          dataIndex: 'updated_at',
          key: 'updated_at',
        },
        {
          title: '操作人',
          dataIndex: 'operator_id',
          key: 'operator_id',
          slots: { customRender: 'operator_id' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}

:deep(.ghost) {
  opacity: 0.5;
  background: #c8ebfb;
}

:deep(.drag-handle),
:deep(.template-drag-handle) {
  user-select: none;
  transition: color 0.2s;
  cursor: move;
  color: #999;
  font-size: 16px;
}

:deep(.drag-handle:hover),
:deep(.template-drag-handle:hover) {
  color: #1890ff;
}

/* 模板项样式 */
:deep(.template-item) {
  margin: 20px 0;
  padding: 15px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  /* cursor: move; */
}

/* 模板项头部样式 */
:deep(.template-header) {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

:deep(.template-header-left) {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* 模板信息容器样式 */
:deep(.template-info-container) {
  margin: 10px 0;
}

/* 模板加载状态样式 */
:deep(.template-loading) {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
  background-color: #f0f0f0;
  border-radius: 4px;
}

/* 模板信息样式 */
:deep(.template-info) {
  padding: 15px;
  background-color: #f5f5f5;
  border-radius: 4px;
  border-left: 4px solid #1890ff;
}

:deep(.template-info-title) {
  margin: 0 0 10px 0;
  color: #1890ff;
  font-size: 14px;
  font-weight: 600;
}

:deep(.template-info-content) {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-start;
}

/* 模板信息图片样式 */
:deep(.template-info-image) {
  flex: 0 0 auto;
}

:deep(.template-info-image img) {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* 模板信息详情样式 */
:deep(.template-info-details) {
  flex: 1;
  min-width: 200px;
}

:deep(.template-info-item) {
  margin-bottom: 8px;
  font-size: 14px;
}

:deep(.template-info-label) {
  color: #666;
  margin-right: 8px;
}

:deep(.template-info-value) {
  color: #333;
}

:deep(.template-info-value.primary) {
  font-weight: 500;
}

/* 表单项样式 */
:deep(.form-item-mb-10) {
  margin-bottom: 10px;
}

.popup-preview {
  padding: 20px;
  
  background: #000;

}
.popup-preview-cover {
  width: 256px;
  max-height: 341px;
  margin: 20px auto;
  border: 1px solid #fff;
  border-radius: 10px;
  display: block;
}
.popup-preview-title{
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  text-align: left;
}
.popup-preview-desc{
  color: #EEE;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
}
.popup-preview-label{
  color: #000;
  text-align: center;
  display: inline-block;
  background: linear-gradient(129.11deg, #DCC9FD 22.58%, #C2D4FF 70.29%);
  height: 20px;
  line-height: 20px;;
  opacity: 1;
  padding: 0 8px;
  gap: 10px;
  font-size:12px;
  border-radius: 6px;

}
.popup-preview-btn{
  border: 2px solid #BE99FF;
  background: #AD7EFF;
  width: 327px;
  height: 48px;
  opacity: 1;
  gap: 4px;
  border-radius: 12px;
  border-width: 2px;
  text-align: center;
  color: #FFF;
  font-size: 18px;
  line-height: 48px;
  margin: 20px auto;

}
</style>